import React from 'react'
import { Switch, useHistory } from 'react-router-dom'
import AppLayout from '../component/AppLayout'
import Download from '../component/Download'
import Catarata from '../pages/Catarata'
import EyeAnatomy from '../pages/EyeAnatomy'
import HelpPage from '../pages/Help'
import Home from '../pages/Home'
import IolPage from '../pages/IolPage'
import LentePage from '../pages/LentePage'
import LesaoRetina from '../pages/LesaoRetina'
import Simulacao from '../pages/Simulacao'
import SurgicalBudget from '../pages/SurgicalBudget'
import { WorkspaceSelector } from '../pages/WorkspaceSelector'
import { useGlobalState } from '../providers/GlobalState'
import { useWorkspace } from '../providers/workspace'
import { PrivateRoute } from './privateRoute'

const AppRouter: React.FC = () => {
  const { loading } = useGlobalState()
  const {
    selectedWorkspace,
    setWorkspaceSelectorOpen,
    setRedirectTo
  } = useWorkspace(
    ({ selectedWorkspace, setWorkspaceSelectorOpen, setRedirectTo }) => ({
      selectedWorkspace,
      setWorkspaceSelectorOpen,
      setRedirectTo
    })
  )
  const history = useHistory()

  React.useEffect(() => {
    if (!selectedWorkspace) {
      setRedirectTo(history.location.pathname)

      history.push('/nav')
      setWorkspaceSelectorOpen(true)
    }
  }, [selectedWorkspace])

  // getting/downloading all data from API
  if (loading) {
    return <Download />
  }

  return (
    <AppLayout>
      <Switch>
        <PrivateRoute path="/nav" exact component={Home} />
        {/* <PrivateRoute path="/nav/pacientes" exact component={Pacientes} /> */}
        {/* <PrivateRoute
          path="/nav/pacientes-novo"
          exact
          component={PacientCreate}
        />
        <PrivateRoute
          path="/nav/pacientes/:pacient_id"
          exact
          component={PacientProfile}
        /> */}
        <PrivateRoute path="/nav/catarata/:slug" component={Catarata} />
        <PrivateRoute path="/nav/lesao" component={LesaoRetina} />
        <PrivateRoute path="/nav/visao" component={Simulacao} />
        <PrivateRoute path="/nav/iol/:iolId/:type" component={IolPage} />
        <PrivateRoute path="/nav/iol/:iolId" component={IolPage} />
        <PrivateRoute
          path="/nav/biblioteca/:libId/:type"
          component={LentePage}
        />
        <PrivateRoute path="/nav/biblioteca/:libId" component={LentePage} />
        <PrivateRoute path="/nav/orcamento" component={SurgicalBudget} />
        <PrivateRoute path="/nav/anatomia-olho" component={EyeAnatomy} />
        <PrivateRoute path="/nav/ajuda/:origin" component={HelpPage} />
      </Switch>

      <WorkspaceSelector />
    </AppLayout>
  )
}

export default AppRouter
